import React, { useEffect, useState } from 'react';
import { Navigate } from 'react-router-dom';
import { useAuth } from '../contexts/AuthContext';
import { getUserAssignedCourses } from '../lib/api';

const HomeRedirect: React.FC = () => {
  const { user, loading } = useAuth();
  const [redirectPath, setRedirectPath] = useState<string | null>(null);

  useEffect(() => {
    const determineRedirectPath = async () => {
      if (user) {
        if (user.role === 'sys') {
          setRedirectPath('/dashboard');
          return;
        }

        try {
          const response = await getUserAssignedCourses(user.id);
          const assignedCourses = response.data;
          
          const permissions = new Set<string>();
          assignedCourses.forEach(course => {
            course.stages?.forEach(stage => {
              stage.lessons?.forEach(lesson => {
                permissions.add(lesson.permission_type);
              });
            });
          });

          const hasEditPermission = permissions.has('edit_develop');
          setRedirectPath(hasEditPermission ? '/dashboard' : '/student/portal');
        } catch (error) {
          console.error('获取权限失败:', error);
          setRedirectPath('/student/portal');
        }
      }
    };

    if (user && !loading) {
      determineRedirectPath();
    }
  }, [user, loading]);

  if (loading || !redirectPath) {
    return null;
  }

  return <Navigate to={redirectPath} replace />;
};

export default HomeRedirect;